import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    pauseOnHover: { type: Boolean, default: true }
  }

  connect() {
    if (this.pauseOnHoverValue) {
      const clip = this.element.querySelector(".gallery-track-clip")
      const target = clip || this.element
      target.addEventListener("mouseenter", () => this.pause())
      target.addEventListener("mouseleave", () => this.resume())
    }
  }

  pause()  {
    this.element.querySelectorAll(".gallery-track").forEach(t => t.classList.add("is-paused"))
  }

  resume() {
    this.element.querySelectorAll(".gallery-track").forEach(t => t.classList.remove("is-paused"))
  }

  prev() {}
  next() {}
}
